import {TWizardOptions} from "../TWizardOptions";

export {isTypeNested};

const isTypeNested = (input: unknown): input is TWizardOptions => {
  
  return true; // todo
}